module.exports = __webpack_public_path__ + "media/images/icons/icon-frown-c361e66b71a77fe6b53293de8540a277.svg";